<template>
  <v-container>
    <v-card>
      <v-card-title>
        Transferências
      </v-card-title>

      <v-tabs v-model="tab">
        <v-tab>Pendentes</v-tab>
        <v-tab>Finalizadas</v-tab>
        <v-tab>Todas</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <TabelaTransferencias ref="tabela_transferencias" :status="status" />
    </v-card>
  </v-container>
</template>

<script>
import TabelaTransferencias from "@/components/locacoes/transferencias/TabelaTransferencias.vue";

export default {
  mixins: [],

  components: { TabelaTransferencias },

  props: {},

  data() {
    return {
      tab: 0
    };
  },

  methods: {},

  computed: {
    status() {
      if (this.tab === 1) {
        return "finalizadas";
      }

      if (this.tab === 2) {
        return "todos";
      }

      return "pendentes";
    }
  }
};
</script>
